import React from "react";

function Dropdown({
  value,
  onChange,
  children,
  align = "center",
  maxWidth = "none",
  className = "",
  selectClassName = "",
  style = {},
}) {
  return (
    <div
      className={`relative ${align === "left" ? "text-left" : align === "right" ? "text-right" : "text-center"} ${className}`.trim()}
      style={{ maxWidth, ...style }}
    >
      <select
        className={`w-full bg-white border border-gray-300 rounded-lg shadow-md py-2 px-3 text-gray-700 focus:ring-2 focus:ring-primary focus:border-primary transition duration-300 ${selectClassName}`.trim()}
        value={value}
        onChange={onChange}
        style={{ width: "257px" }}
      >
        {children}
      </select>
    </div>
  );
}

export default Dropdown;
//тестт
